import { render } from "./epro.vue?vue&type=template&id=23450376&scoped=true"
import script from "./epro.js?vue&type=script&lang=js"
export * from "./epro.js?vue&type=script&lang=js"

import "./epro.vue?vue&type=style&index=0&id=23450376&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23450376"]])

export default __exports__